import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#DE0000" }, [
      _createElementVNode("path", { d: "M8 14.5a5 5 0 0 1-4.84-6.26l-1.263-.98A6.496 6.496 0 0 0 8 15.997a6.45 6.45 0 0 0 3.672-1.139l-1.26-.98A4.96 4.96 0 0 1 8 14.5M15.631 14.122l-1.931-1.5c.51-.928.8-1.99.8-3.125 0-1.397-.44-2.69-1.19-3.75l.968-.969a.75.75 0 0 0-1.06-1.06l-.912.916a6.45 6.45 0 0 0-3.556-1.59V1.5h1c.416 0 .75-.334.75-.75A.75.75 0 0 0 9.75 0h-3.5a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h1v1.544a6.48 6.48 0 0 0-3.681 1.7L1.234 2.928a.75.75 0 0 0-1.053.131.754.754 0 0 0 .132 1.053l2.284 1.776 1.187.925 7.86 6.112 1.187.922 1.878 1.462a.751.751 0 0 0 .922-1.187M8.75 8.772V6.75A.75.75 0 0 0 8 6a.75.75 0 0 0-.75.75v.856L4.775 5.681a4.999 4.999 0 0 1 7.722 6.003z" })
    ], -1)
  ]))]))
}
export default { render: render }